import React, { useRef, useState } from "react";
import { Button } from "@mui/material";
import { CloudUpload, GetApp } from "@mui/icons-material";
import * as XLSX from "xlsx";
import axios from "axios";
import Swal from "sweetalert2";
import Apiurl from "../../Helpers/apiUrl";
import LoadingIndicator from "./LoadingIndicator";

const COLUMN_MAP = {
  GST_NO: "GST No.*",
  NAME: "First Name*",
  LAST_NAME: "Last Name*",
  PHONE: "Phone Number*",
  EMAIL: "Email*",
  REGION: "Region",
  STATE: "State",
};

const apiPath = `${Apiurl}admin/user-bulk_upload`;
const token = localStorage.getItem("u_token");

const BulkUploadUser = () => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleDownloadTemplate = () => {
    const worksheetData = [
      [
        COLUMN_MAP.GST_NO,
        COLUMN_MAP.NAME,
        COLUMN_MAP.LAST_NAME,
        COLUMN_MAP.PHONE,
        COLUMN_MAP.EMAIL,
        COLUMN_MAP.REGION,
        COLUMN_MAP.STATE,
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dealer Template");
    XLSX.writeFile(workbook, "Dealer_Bulk_Upload.xlsx");
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const jsonData = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]],
          { defval: "" }
        );

        const validatedData = [];
        const errors = [];

        jsonData.forEach((item, index) => {
          const rowNum = index + 2;
          
          if (!item[COLUMN_MAP.NAME] && !item[COLUMN_MAP.EMAIL] && !item[COLUMN_MAP.GST_NO]) {
            return; 
          }

          const gstNo = item[COLUMN_MAP.GST_NO];

          if (
            !item[COLUMN_MAP.NAME] ||
            !item[COLUMN_MAP.LAST_NAME] ||
            !item[COLUMN_MAP.EMAIL] ||
            !item[COLUMN_MAP.PHONE] ||
            !gstNo
          ) {
            errors.push(`Row ${rowNum}: Required fields (*) are missing.`);
          } else {
            validatedData.push({
              user_type: "Dealer", 
              emp_code: gstNo,
              name: item[COLUMN_MAP.NAME],
              last_name: item[COLUMN_MAP.LAST_NAME],
              phone: item[COLUMN_MAP.PHONE],
              email: item[COLUMN_MAP.EMAIL],
              city: item[COLUMN_MAP.REGION],
              state: item[COLUMN_MAP.STATE],
              role: 7, 
            });
          }
        });

        if (errors.length > 0) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            html: `<div style="text-align:left; font-size:12px;">${errors.slice(0, 5).join("<br/>")}</div>`,
          });
          return;
        }

        if (validatedData.length === 0) {
            setLoading(false);
            Swal.fire({ icon: "info", title: "No Data", text: "The uploaded file is empty." });
            return;
        }

        await sendToApi(validatedData);
      } catch (err) {
        setLoading(false);
        Swal.fire({ icon: "error", title: "Error", text: "Could not process the file." });
      }
    };
    reader.readAsArrayBuffer(file);
    e.target.value = null;
  };

  const sendToApi = async (data) => {
    try {
      await axios.post(
        apiPath,
        { users: data },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      Swal.fire({ icon: "success", title: "Success", text: "Dealers uploaded successfully." });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: error.response?.data?.error || "Server Error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex gap-2 w-fit items-center">
      <LoadingIndicator show={loading} />

      <Button
        variant="outlined"
        startIcon={<GetApp />}
        onClick={handleDownloadTemplate}
        className="capitalize font-bold border-slate-300 text-slate-700 rounded-xl px-6 py-2 hover:bg-slate-50 transition-all"
          sx={{
    py: "2px",
    px: "14px",
    borderRadius: 12,
    fontSize: "12px",
    whiteSpace: "nowrap",
  }}
      >
        Dealer Template
      </Button>

      <input
        type="file"
        accept=".xlsx, .xls"
        className="hidden"
        ref={fileInputRef}
        onChange={handleFileUpload}
      />

    <Button
  variant="contained"
  startIcon={<CloudUpload />}
  onClick={() => fileInputRef.current.click()}
  className="capitalize font-bold bg-slate-900 hover:bg-black text-white shadow-none transition-all"
  sx={{
    py: "2px",
    px: "14px",
    borderRadius: 12,
    fontSize: "12px",
    whiteSpace: "nowrap",
  }}
>
  Bulk Upload
</Button>
    </div>
  );
};

export default BulkUploadUser;